import { render, staticRenderFns } from "./DepositRow.vue?vue&type=template&id=c0bea6c2"
import script from "./DepositRow.vue?vue&type=script&lang=js"
export * from "./DepositRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports